import React from "react";
import { Link } from "react-router-dom";
import "../Pages/Main.css";

function MapsBannerSlider() {
  const content = {
    label: "Pharmacy Management Software",
    title: "Strengthen Operational Control",
    description:
      "ClinTa MAPS is a complete pharmacy management system built for efficiency and control. From inventory tracking to financial oversight, everything is unified in one platform. Reduce losses, improve performance, and drive stronger profitability.",
  };

  return (
    <section
      className="position-relative bg-image pt-60 pb-100 maps-hero-section"
      image-overlay="8"
    >
      <div
        className="background-image-wraper"
        style={{
          background: `url('/assets/img/homepage-maps.svg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          opacity: 1,
        }}
      ></div>
      <div className="container">
        <div className="row align-items-center min-vh-75">
          <div className="col-lg-9 col-md-12">
            <div className="hero-glass-card p-5 hero-glass-animated">
              <span className="badge badge-primary mb-3 d-inline-block hero-glass-badge">
                {content.label}
              </span>
              <h1 className="font-weight-bold mb-4 hero-glass-title">
                {content.title}
              </h1>
              <p className="lead mb-4 hero-glass-description">
                {content.description}
              </p>
              <div className="action-btns hero-glass-buttons">
                <Link
                  to="/request-a-demo?product=MAPS"
                  className="btn btn-brand-03 btn-rounded hero-glass-btn-primary"
                >
                  Request a Demo
                  <i className="fas fa-arrow-right pl-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MapsBannerSlider;
